import columns from '../../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredTextColumn,
    FilteredNonZeroNumberColumn,
    FilteredDateTimeColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Outbound Operator', 'outboundOperator').withWidth(100),
        new FilteredTextColumn('Outbound IMPC', 'outboundImpc').withWidth(100),
        new FilteredTextColumn('Inbound Operator', 'inboundOperator').withWidth(100),
        new FilteredTextColumn('Inbound IMPC', 'inboundImpc').withWidth(100),
        new FilteredDateTimeColumn('Departure date', 'departureDate').withWidth(140),
        new FilteredDateTimeColumn('Arrival date', 'arrivalDate').withWidth(140),
        new FilteredTextColumn('Type', 'transactionType').withWidth(90),
        new FilteredNonZeroNumberColumn('Quantity preadvised', 'quantityPreAdvised').withWidth(110),
        new FilteredNonZeroNumberColumn('Quantity confirmed', 'quantityConfirmed').withWidth(110),
        new FilteredNonZeroNumberColumn('Quantity objected', 'quantityObjected').withWidth(110),
        new FilteredTextColumn('Who', 'creationUser').withWidth(90),
        new ExternalDespatchLinkColumn(new FilteredTextColumn('Despatch ID', 'despatchId').withWidth(235)),
        new FilteredTextColumn('Status', 'status').withWidth(100),
        new FilteredTextColumn('Comments', 'comments').withWidth(100),
        new FilteredNonZeroNumberColumn('Id', 'id').withWidth(100),
        new FilteredDateTimeColumn('Loading date & time ', 'loadingDateTime').withWidth(140),
        new FilteredTextColumn('Transport Duration', 'transportDuration'),
        new FilteredTextColumn('Message Delay', 'messageDelay'),
        new FilteredTextColumn('Age', 'age'),
      ],
    },
  ];
};
